import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SchemaService {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  addOrganizationSchema() {

    // Prevent duplicate insertion
    if (this.document.getElementById('organization-schema')) {
      return;
    }

    const script = this.document.createElement('script');

    script.type = 'application/ld+json';
    script.id = 'organization-schema';

    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Varroc Connect",
      "alternateName": "varrocconnect",
      "url": "https://varrocconnect.com/",
      "logo": "https://varrocconnect.com/assets/images/websitev2/varroc-connect-logo.png",
      "sameAs": [
        "https://www.linkedin.com/company/varrocconnect/",
        "https://www.facebook.com/varrocconnect/",
        "https://x.com/varrocconnect",
        "https://www.instagram.com/varroc_connect"
      ]
    });

    this.document.head.appendChild(script);
  }
}